'use client';
import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
`;
